// extracted by mini-css-extract-plugin
export default {"createForm":"CreateForm_createForm__Pdil9","uploadSection":"CreateForm_uploadSection__gWAhp","sizeMessage":"CreateForm_sizeMessage__8c1X5"};